import { render } from "./AuthModal.vue?vue&type=template&id=ff17531e&bindings={\"modelValue\":\"props\",\"loginWith\":\"setup\",\"updateModal\":\"setup\"}"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"
script.render = render

export default script